# Some global variables
# Because we probably need these in other ready things, let's put them in global scope.
# The (meata tags in the) header is (are) loaded by this time anyways.
window.baseurl = $("meta[name='baseurl']").attr("content")
window.csrftoken = $("meta[name='csrftoken']").attr("content")
window.userid = parseInt($("meta[name='userid']").attr("content"))
window.playercolors = {
    0: 'gray'
    1: 'green'
    2: 'blue'
    3: 'red'
    4: 'pink'
    5: 'purple'
    6: 'orange'
    7: 'black'
    8: 'yellow'
    9: 'cyan'
    # 10: 'blue-thing'
    # 11: 'dark-green-thing'
    # 12: 'dark-red-thing'
    # 13: 'pink-purple-thing'
    # 14: 'just-purple-thing'
    # 15: 'dark-yellow-thing'
}

# Helper functions
window.tt_tooltip = D12App.tt_tooltip
window.tt_icon = D12App.tt_icon

String::ucfirst = () -> D12App.ucfirst(this)

window.isNumeric = (n) -> not isNaN(parseFloat(n)) and isFinite(n)

window.noun = (singular, plural, count) ->
    return if count is 1 then singular else plural
window.verb = window.noun

# window.copyToClipboardLink = (link, text) ->
#     $(link).click(() ->
#         $(text).select()
#         try
#             success = document.execCommand('copy')
#             console.log(success)
#         catch err
#             console.log(err)
#     )

window.queue = (callback) ->
    setTimeout(callback, 0)

#
# Ajax
#
window.ajaxLoader = '<i class="fa fa-spinner fa-pulse loader"></i>'
window.ajaxSuccess = '<i class="fa fa-check success"></i>'
window.ajaxWarning = '<i class="fa fa-question-circle"></i>'
window.ajaxError = '<i class="fa fa-times error"></i>'

# For typescript version: use ajaxClient.reportError(reason)
window.reportAjaxError = (jqXHR, textStatus, errorThrown) ->
    messageDisplay.error(errorThrown)

#
# Clientside cookies
# Thanks SO (http://stackoverflow.com/questions/14573223/set-cookie-and-get-cookie-with-javascript)
#
window.createCookie = (name, value, time) ->
    unit = time.slice(-1)
    if (isNumeric(unit))
        throw new Error('No unit was specified.')

    if time
        date = moment().add(parseInt(time.slice(0, -1)), unit)
        expires = "; expires=#{date.toDate().toUTCString()}"
    else expires = ""
    document.cookie = "#{name}=#{value}#{expires}; path=/"

window.readCookie = (name) ->
    nameEQ = name + "="
    ca = document.cookie.split(';')
    for i in [0 ... ca.length]
        c = ca[i]
        while c.charAt(0) is ' '
            c = c.substring(1, c.length)
        if (c.indexOf(nameEQ) is 0)
            return c.substring(nameEQ.length, c.length)
    return null

window.eraseCookie = (name) ->
    createCookie(name, '', '-1s')

# DEBUG
window.dd = (obj) ->
    alert(JSON.stringify(obj, null, 4))
